/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect, memo } from 'react';
import { Link } from 'react-router-dom';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import styled from 'styled-components';
import { Carousel } from 'react-bootstrap';
import LoadContent from './elementsDS/Loaders/LoadContent';

const BsChevronLeftHome = styled(BsChevronLeft)`
  background-color: transparent;
  color: transparent;
  border-radius: 0;
  padding: 5;
  boxshadow: "0px 5px 7px 0px rgba(208, 207, 207, 0.60)";
`;
const BsChevronRightHome = styled(BsChevronRight)`
  background-color: transparent;
  color: transparent;
  border-radius: 0;
  padding: 5;
  boxshadow: "0px 5px 7px 0px rgba(208, 207, 207, 0.60)";
`;

const ImageComponent = ({ link, productId, urlRedirect }) => {
  if (urlRedirect && urlRedirect !== '') {
    return (
      <a href={urlRedirect}>
        <img src={link} className="d-block w-100" alt="..." />
      </a>
    );
  } else if (productId && productId !== '') {
    return (
      <Link to={`/ProductDetails/${productId}`}>
        <img src={link} className="d-block w-100" alt="..." />
      </Link>
    );
  } else {
    return <img src={link} className="d-block w-100" alt="..." style={{height:"80vh" }}/>;
  }

  // return <img src="./img/banners/Carrousel.png" className="d-block w-100" alt="..." />
};

const styles = {
  container: {
    overflow: 'hidden',
    height:  '80vh',  // Ahora en móvil será 50vh
    width: '100%',
  },
};

const Carrousel = ({banners}) => {
  //const [banners, setBanners] = useState(banners);
  const [ready, setReady] = useState(true);

  useEffect(() => {
    
  }, []);
  const children = () => {
    if (!ready) {
      return (
        <div
          style={{
            minHeight: '26vh',
            alignContent: 'center',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
          >
          <LoadContent />
        </div>
      );
    } else if (ready) {
      if (banners.length > 0) {
        return (
          <Carousel
            indicators
            id="carouselExampleFade"
            className="carousel slide carousel-fade "
            data-ride="carousel"
            prevIcon={(
              <a
                className="carousel-custom-previous"
                >
                <BsChevronLeftHome className="style-arrow-carrousel" size={30} color='#fff'/>
                <span className="sr-only" />
              </a>
            )}
            nextIcon={(
              <a
                className="carousel-custom-next"
                data-slide="next"
                >
                <BsChevronRightHome className="style-arrow-carrousel" size={30} color='#fff'/>
                <span className="sr-only" />
              </a>
            )}
            >
            {banners.map((banner, i) => (

              <Carousel.Item key={`banner${i}`}>
                <ImageComponent
                  //productId={banner.productId}
                  link={banner.link}
                  //urlRedirect={banner.urlRedirect}
                  />
              </Carousel.Item>

            ))}
          </Carousel>
        );
      } else return null;
    }
  };
  return <div style={styles.container}>{children()}</div>;
};

export default memo(Carrousel);
